var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"home-card-counter float-right",attrs:{"title":"Total"}},[_c('animated-number',{attrs:{"value":_vm.value,"formatValue":_vm.formatValue,"duration":4000,"easing":'easeOutCirc'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }